import { Controller } from "@hotwired/stimulus"

// Preview-only: hide or show the yellow review highlight without touching
// comments, approval requests, or their markers. The class lives on the reader
// so every reviewable block — text, images, polls, child rows — is covered by
// one CSS rule. sessionStorage keeps the choice when the reviewer changes
// lessons; a new tab starts with highlights on.
const STORAGE_KEY = "tms.coursePreview.reviewHighlightsHidden"
const HIDDEN_CLASS = "is-review-highlights-hidden"

export default class extends Controller {
  static targets = ["toggle"]

  connect() {
    this.apply(this.storedHidden())
  }

  change() {
    this.apply(!this.toggleTarget.checked)
    this.persist()
  }

  apply(hidden) {
    this.reader()?.classList.toggle(HIDDEN_CLASS, hidden)
    if (this.hasToggleTarget) this.toggleTarget.checked = !hidden
  }

  persist() {
    this.writeStorage(this.hasToggleTarget && !this.toggleTarget.checked)
  }

  storedHidden() {
    try {
      return sessionStorage.getItem(STORAGE_KEY) === "1"
    } catch {
      return false
    }
  }

  writeStorage(hidden) {
    try {
      sessionStorage.setItem(STORAGE_KEY, hidden ? "1" : "0")
    } catch {
      // Private mode can reject sessionStorage; the in-page class still applies.
    }
  }

  reader() {
    return this.element.closest(".academy-reader")
  }
}
